import { render, staticRenderFns } from "./CurriculumJournalActivityCell.vue?vue&type=template&id=35bf659e&scoped=true&"
import script from "./CurriculumJournalActivityCell.vue?vue&type=script&lang=ts&"
export * from "./CurriculumJournalActivityCell.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumJournalActivityCell.vue?vue&type=style&index=0&id=35bf659e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf659e",
  null
  
)

export default component.exports